import {
  Divider,
  Grid2,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";

const Section2 = () => {
  return (
    <>
      <Typography variant="h4" gutterBottom>
        Authentication and Access Control
      </Typography>
      <Typography sx={{ fontSize: "1.1rem" }} variant="body1" mb={2}>
        Employees access the Application using an official email ID and password
        provided by the employer. Where a password reset is required, a One-Time
        Password (OTP) is sent to the employee’s official email address to
        verify identity and authorize the reset. This process ensures secure
        authentication and prevents unauthorized access.
      </Typography>
      <Typography sx={{ fontSize: "1.1rem" }} variant="body1" mb={2}>
        Access within the Application is governed by role-based permissions:
      </Typography>

     <Grid2 container spacing={2} ml={4}>
  <Grid2 size={{ xs: 12 }}>
    <List sx={{ fontSize: "1.1rem" }}>
      
      <ListItem alignItems="flex-start">
        <ListItemText
          primary="• Employees can access their own profile, attendance, leave, payslips and performance data."
          primaryTypographyProps={{
            sx: { textAlign: "justify", fontSize: "1.1rem" }
          }}
        />
      </ListItem>

      <ListItem alignItems="flex-start">
        <ListItemText
          primary="• Managers can view and approve requests such as leave, work-from-home, permission and regularization for employees reporting to them."
          primaryTypographyProps={{
            sx: { textAlign: "justify", fontSize: "1.1rem" }
          }}
        />
      </ListItem>

      <ListItem alignItems="flex-start">
        <ListItemText
          primary="• Human Resources personnel have elevated access solely for administrative, operational and statutory purposes."
          primaryTypographyProps={{
            sx: { textAlign: "justify", fontSize: "1.1rem" }
          }}
        />
      </ListItem>

    </List>
  </Grid2>
</Grid2>


      <Divider sx={{ my: 2 }} />
    </>
  );
};

export default Section2;
